export default function(url) {
  return url.slice(url.indexOf("?") + 1);
}
